
/**
 * Order is relevant for this enum. The ordinal is equal to the mouth sprite's frames to be used for that sound.
 */
export enum Sound {
    CLOSED,
    A,
    E,
    O,
    U,
    CON,
    FV,
    L,
    MBP,
}